import React from 'react';

export default function FirstFightSection() {
  return (
    <section id="first-fight" style={{
      padding: 'clamp(60px, 10vw, 120px) 24px',
      background: 'linear-gradient(180deg, #080612 0%, #0e0618 50%, #0d0a14 100%)',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* BG */}
      <div style={{
        position: 'absolute', inset: 0,
        background: 'radial-gradient(ellipse at 50% 50%, rgba(251,146,60,0.05) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: 60, alignItems: 'center',
        }}>
          {/* Text */}
          <div>
            <div className="section-badge" style={{ borderColor: 'rgba(251,146,60,0.3)', background: 'rgba(251,146,60,0.08)' }}>
              <span>⚡</span> Chapter 4
            </div>
            <h2 style={{
              fontFamily: 'Poppins, sans-serif', fontWeight: 800,
              fontSize: 'clamp(32px, 6vw, 56px)', lineHeight: 1.15, marginBottom: 8,
            }}>
              First <span style={{
                background: 'linear-gradient(135deg, #fb923c, #f43f5e)',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}>Fight</span> Between Us
            </h2>
            <div className="section-divider" style={{ background: 'linear-gradient(90deg, #fb923c, #f43f5e)' }} />
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              padding: '8px 18px',
              background: 'rgba(251,146,60,0.08)',
              border: '1px solid rgba(251,146,60,0.2)',
              borderRadius: 50, fontFamily: 'Nunito, sans-serif', fontSize: 14,
              color: '#fb923c', marginBottom: 24,
            }}>
              📅 18 August 2025
            </div>
            <p style={{
              fontFamily: 'Nunito, sans-serif', fontSize: 16, lineHeight: 1.9,
              color: '#9b7ba8', marginBottom: 20,
            }}>
              Every real relationship has its storms. It all started with a simple game invite. Hassan sent a Ludo request to Fiza, but she didn't accept it. Instead, she told him, "I’m already in a game right now, just wait a bit." Hassan felt a spark of doubt and started thinking that maybe she wasn't actually playing. This small doubt quickly spiraled into a heated argument. Both said some harsh things to each other, and for a moment, it felt like their strong friendship bond was beginning to crack.🌩️
            </p>
            <p style={{
              fontFamily: 'Nunito, sans-serif', fontSize: 16, lineHeight: 1.9,
              color: '#9b7ba8', marginBottom: 32,
            }}>
              However, after the dust settled, they realized that their connection was much more important than a game or a misunderstanding. They both reached out, said "Sorry," and finally ended the fight. In the end, their friendship came out even stronger.. 💛
            </p>

            <div style={{
              background: 'linear-gradient(135deg, rgba(251,146,60,0.08), rgba(244,63,94,0.06))',
              border: '1px solid rgba(251,146,60,0.15)',
              borderRadius: 16, padding: '20px 24px',
              marginBottom: 32,
            }}>
              <p style={{
                fontFamily: 'Nunito, sans-serif', fontSize: 15, lineHeight: 1.8,
                color: '#e2c8d8', fontStyle: 'italic',
              }}>
                "The first fight shows you're real. Making up shows you're worth it." 💕
              </p>
            </div>

            {/* Tags */}
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              {['😤 Misunderstanding', '💔 Hard Moment', '🌈 Made Up', '💛 Grew Stronger'].map(t => (
                <span key={t} style={{
                  padding: '8px 16px',
                  background: 'rgba(251,146,60,0.06)',
                  border: '1px solid rgba(251,146,60,0.12)',
                  borderRadius: 50, fontFamily: 'Nunito, sans-serif', fontSize: 13,
                  color: '#fb923c',
                }}>{t}</span>
              ))}
            </div>
          </div>

          {/* Illustration */}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ position: 'relative', animation: 'float 6s ease-in-out infinite' }}>
              <svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', maxWidth: 300 }}>
                <defs>
                  <linearGradient id="fightGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#fb923c" />
                    <stop offset="100%" stopColor="#f43f5e" />
                  </linearGradient>
                  <radialGradient id="bgFight" cx="50%" cy="50%" r="50%">
                    <stop offset="0%" stopColor="rgba(251,146,60,0.1)" />
                    <stop offset="100%" stopColor="rgba(0,0,0,0)" />
                  </radialGradient>
                </defs>
                <circle cx="150" cy="150" r="130" fill="url(#bgFight)" />

                {/* Boy on left - arms crossed, looking away */}
                <circle cx="85" cy="110" r="22" fill="#2d1f4a" />
                <circle cx="78" cy="106" r="4" fill="#a855f7" />
                <circle cx="92" cy="106" r="4" fill="#a855f7" />
                <circle cx="78" cy="106" r="2" fill="#1a0a2e" />
                <circle cx="92" cy="106" r="2" fill="#1a0a2e" />
                <path d="M79,118 Q85,115 91,118" stroke="#9b7ba8" strokeWidth="2" fill="none" strokeLinecap="round" />
                <rect x="65" y="132" width="40" height="50" rx="12" fill="#2d1f4a" />
                <rect x="65" y="132" width="40" height="20" rx="8" fill="#3d2a5a" />
                {/* Arms crossed */}
                <path d="M60,145 Q70,140 75,145 Q80,150 85,145" stroke="#2d1f4a" strokeWidth="12" strokeLinecap="round" fill="none" />
                <path d="M110,145 Q100,140 95,145 Q90,150 85,145" stroke="#2d1f4a" strokeWidth="12" strokeLinecap="round" fill="none" />

                {/* Girl on right - hands on hips */}
                <circle cx="215" cy="110" r="22" fill="#2d1f4a" />
                {/* Girl hair */}
                <path d="M196,105 Q194,92 202,88 Q210,84 218,88 Q228,92 226,105" fill="#1a0a2e" />
                <path d="M196,105 Q192,115 196,128" stroke="#1a0a2e" strokeWidth="10" strokeLinecap="round" fill="none" />
                <path d="M226,105 Q230,115 226,128" stroke="#1a0a2e" strokeWidth="10" strokeLinecap="round" fill="none" />
                <circle cx="208" cy="106" r="4" fill="#ff6b9d" />
                <circle cx="222" cy="106" r="4" fill="#ff6b9d" />
                <circle cx="208" cy="106" r="2" fill="#1a0a2e" />
                <circle cx="222" cy="106" r="2" fill="#1a0a2e" />
                {/* Eyebrows furrowed */}
                <path d="M205,99 Q208,97 211,99" stroke="#ff9db5" strokeWidth="1.5" fill="none" />
                <path d="M219,99 Q222,97 225,99" stroke="#ff9db5" strokeWidth="1.5" fill="none" />
                <path d="M209,118 Q215,115 221,118" stroke="#9b7ba8" strokeWidth="2" fill="none" strokeLinecap="round" />
                <rect x="195" y="132" width="40" height="50" rx="12" fill="#2d1f4a" />
                <rect x="195" y="132" width="40" height="20" rx="8" fill="#ff6b9d" />
                {/* Hands on hips */}
                <path d="M190,155 Q195,148 200,152" stroke="#2d1f4a" strokeWidth="11" strokeLinecap="round" fill="none" />
                <path d="M240,155 Q235,148 230,152" stroke="#2d1f4a" strokeWidth="11" strokeLinecap="round" fill="none" />

                {/* Dispute sparks in middle */}
                <text x="138" y="100" fontSize="22">⚡</text>
                <text x="148" y="130" fontSize="18" opacity="0.7">💢</text>
                <text x="128" y="125" fontSize="16" opacity="0.5">✨</text>

                {/* Broken heart */}
                <path d="M145,165 C145,158 138,152 138,160 C138,168 145,174 145,174 C145,174 152,168 152,160 C152,152 145,158 145,165 Z" fill="url(#fightGrad)" opacity="0.7" />
                <line x1="145" y1="158" x2="147" y2="166" stroke="rgba(0,0,0,0.5)" strokeWidth="1.5" />

                {/* Speech bubbles */}
                <rect x="50" y="60" width="55" height="22" rx="8" fill="#2d1f4a" />
                <polygon points="70,82 65,90 78,82" fill="#2d1f4a" />
                <text x="77" y="75" textAnchor="middle" fill="#9b7ba8" fontSize="9" fontFamily="Nunito, sans-serif">Yeh theek...</text>
                <text x="77" y="85" textAnchor="middle" fill="#9b7ba8" fontSize="9" fontFamily="Nunito, sans-serif">nahi hai!</text>

                <rect x="195" y="60" width="58" height="22" rx="8" fill="#2d1f4a" />
                <polygon points="215,82 220,90 226,82" fill="#2d1f4a" />
                <text x="224" y="75" textAnchor="middle" fill="#9b7ba8" fontSize="9" fontFamily="Nunito, sans-serif">Main bhi</text>
                <text x="224" y="85" textAnchor="middle" fill="#9b7ba8" fontSize="9" fontFamily="Nunito, sans-serif">sahi hun!</text>
              </svg>

              {/* Date badge */}
              <div style={{
                position: 'absolute', bottom: -10, left: '50%', transform: 'translateX(-50%)',
                background: 'linear-gradient(135deg, #fb923c, #f43f5e)',
                padding: '10px 24px', borderRadius: 50,
                fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: 13,
                color: 'white', whiteSpace: 'nowrap',
                boxShadow: '0 8px 30px rgba(251,146,60,0.4)',
              }}>
                18 August 2025 ⚡
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}